import { useState, useEffect } from "react";
import { getMetroType } from "../utilities/utilities";

interface IProps {
	activeSchedule: any,
	customSchedule: any,
	routeId: number,
}
interface CustomScheduleTable {
	Title: string,
	SubTitle: string,
	RowData: string[][],
}
interface Trips {
	Id: string,
	Modified: boolean,
	Times: string[],
}
function RouteTable({ activeSchedule, customSchedule, routeId }: IProps) {
	const [tableType, updateTableType] = useState('');
	const [routeData, updateRouteData] = useState(activeSchedule);
	const [customRouteData, updateCustomRouteData] = useState(customSchedule);

	useEffect(() => {
		updateCustomRouteData(customSchedule);
		const metroId = getMetroType(routeId);
		updateTableType(`route-table__sub-header--${metroId}`);
		updateRouteData(activeSchedule);
	}, [activeSchedule, routeId, customSchedule]);

	if (customRouteData) {
		return (
			<>
				<span className="visually-hidden" aria-live="polite">showing table route results for {activeSchedule.RouteTitle}</span>
				{
					customRouteData.Tables.map((item: CustomScheduleTable, tableIndex: number) => {
						return (
							<table className="route-table route-table--secondary" key={tableIndex}>
								<caption className="route-table__caption">
									<span className="route-table__label">{item.Title}</span>
									<span className="route-table__sub-label">{item.SubTitle}</span>
								</caption>
								<thead className="route-table__thead">
									<tr className="route-table__row">
										{
											item.RowData.length > 0 && item.RowData[0].map((cell,index) => {
												return (
													<th className="route-table__cell route-table__cell--header" key={index}>{cell}</th>
												)
											})
										}
									</tr>
								</thead>
								<tbody className="route-table__tbody">
									{
										item.RowData.map((rowItem, index) => {
											if (index > 0) {
												return (
													<tr className="route-table__row" key={index}>
														{
															rowItem.map((cell, cellIndex) => {
																return (
																	<td className="route-table__cell" key={cellIndex}>{cell}</td>
																)
															})
														}
													</tr>
												)
											}
										})
									}
								</tbody>
							</table>
						)
					})
				}
			</>
		)
	}
	return (
		<>
			<span className="visually-hidden" aria-live="polite">showing table route results for {activeSchedule.RouteTitle}</span>
			<table className="route-table">
				<thead className="route-table__thead">
					<tr className="route-table__row">
						{
							routeData.TimeStops.map((stop: string[],index:number) => {
								let id = index + 1;
								// routes 640 and 642 have clockwise routes
								if (index === routeData.TimeStops.length - 1 && (routeData.ScheduleTitle.includes("Clockwise"))) {
									id = 1;
								}
								return (
									<th className="route-table__header" key={index}>
										<span className="route-table__stop">{stop}</span>
										<div className={`route-table__sub-header ${tableType}`}>
											<span className="route-table__id">{id}</span>
										</div>
									</th>
								)
							})
						}
					</tr>
				</thead>
				<tbody className="route-table__tbody">
					{
						routeData.Trips.map((trip:Trips, index:number) => {
							return (
								<tr className="route-table__row" key={index}>
									{trip.Times.map((time, timeIndex) => {
										const pmClass = time.indexOf('p') > -1 
											? 'route-table__cell--secondary'
											: '';
										return (
											<td className={`route-table__cell ${pmClass}`} key={timeIndex}>{time}</td>
										)
									})}
								</tr>
							)
						})
					}
				</tbody>
			</table>
		</>
	)
}
export default RouteTable;